import { Injectable } from '@angular/core';

@Injectable()
export abstract class LogoutService {
    logout:() => Promise<any>
    removeTokens:() => void
}